import {atomWithStorage} from 'jotai/utils';

import {CalendarPeopleFilterState} from './calendarPeopleGroups';

/** Per-group PTO visibility overrides. Unset keys use {@link CALENDAR_PEOPLE_GROUP_DEFAULTS}. */
export const calendarPeopleFilterAtom = atomWithStorage<CalendarPeopleFilterState>(
  'dashboard:calendarPeopleFilter:v2',
  {}
);
